/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactDealerButton_user = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_user">;
    readonly " $refType": "PdpSharedContactDealerButton_user";
};
export type PdpSharedContactDealerButton_user$data = PdpSharedContactDealerButton_user;
export type PdpSharedContactDealerButton_user$key = {
    readonly " $data"?: PdpSharedContactDealerButton_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedContactDealerButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    }
  ]
};
(node as any).hash = '21b649f52a68f21cd76c8eb476bcdf13';
export default node;
